import script from "./ProvisioningAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvisioningAdminView.vue?vue&type=script&setup=true&lang=js"

import "./ProvisioningAdminView.vue?vue&type=style&index=0&id=78f2e9f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f2e9f1"]])

export default __exports__